// Sprint 6 (Phase 1) — DualModeChip (header chip variant).
//
// Per-message expanders live inside FounderToolRow. This component renders
// the **header chip** that shows up only when the global "Show developer
// details" toggle is ON. The chip serves three purposes:
//   1. Tells the founder "you are NOT seeing the default founder mode".
//   2. Provides a one-click revert.
//   3. Reinforces founder-first by making developer-mode feel borrowed,
//      not native.
//
// When the global toggle is OFF (default), this component renders nothing.

import { Icon } from '../atoms/Icon';
import { useSettingsStore } from '../../stores/settings.store';
import { useTranslation } from '../../i18n';

export function DualModeHeaderChip() {
  const { t } = useTranslation();
  const developerMode = useSettingsStore((s) => s.developerMode);
  const setDeveloperMode = useSettingsStore((s) => s.setDeveloperMode);
  if (!developerMode) return null;
  return (
    <button
      type="button"
      onClick={() => setDeveloperMode(false)}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-2xs uppercase tracking-wide bg-secondary/60 text-muted-foreground border border-border hover:bg-secondary/80 focus:outline-none focus:ring-1 focus:ring-border" /* design-discipline: kept as text-2xs — tiny chip label */
      data-testid="dual-mode-header-chip"
      aria-label={t('dualMode.disableTooltip')}
      title={t('dualMode.disableTooltip')}
    >
      {t('dualMode.label')}
      <Icon name="X" size={10} aria-hidden="true" />
    </button>
  );
}
